import { Platform, type ViewStyle } from 'react-native';

/**
 * Suppress the browser focus ring on RN Web without the CSS `outline` shorthand
 * (React Native rejects `outline` — use long-form properties).
 */
export const webOutlineNone: ViewStyle = Platform.select({
  web: {
    outlineStyle: 'none',
    outlineWidth: 0,
  },
  default: {},
}) as ViewStyle;
